export default {"src":"/_next/static/media/fraxlend.01312694.svg","height":283,"width":283,"blurWidth":0,"blurHeight":0};